import AwesomeTable from './AwesomeTable';

export default AwesomeTable;
